import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const customerinvoiceaddress = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/quotation/{profile}/customer-invoice-address',
    app: 'quotation'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'quotation', model: 'customerinvoiceaddress' }
    ),
    { }
  )
)()

export { customerinvoiceaddress, TYPES }
